import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Chip,
  Divider,
  IconButton
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { getLocaleDateTime, getShortLocaleDateTime } from 'app/utils/appHelpers';
import { primaryColor } from 'app/themes/main/default';
import parse from 'html-react-parser';

function AnnouncementItemDialog({ open, onClose, announcement }) {



  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle
        sx={{
          pb: 2,
          background: primaryColor,
          color: 'white',
          position: 'relative'
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1, pr: 4 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 1,
                lineHeight: 1.3,
                color: 'white'
              }}
            >
              {announcement.title}      ({getShortLocaleDateTime(announcement.addedDate)})
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 3,
          pb: 2,
          px: 3,
          background: '#fafafa'
        }}
      >
        <Box sx={{
          background: 'white',
          p: 3,
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          border: '1px solid #e0e0e0'
        }}>
          <Box
            sx={{
              lineHeight: 1.8,
              fontSize: '13px',
              color: '#2c3e50',
              textAlign: 'justify',
              '& h1, & h2, & h3, & h4, & h5, & h6': {
                marginTop: '1em',
                marginBottom: '0.5em',
                fontWeight: 'bold'
              },
              '& p': {
                marginBottom: '1em'
              },
              '& ul, & ol': {
                marginBottom: '1em',
                paddingLeft: '2em'
              },
              '& li': {
                marginBottom: '0.5em'
              },
              '& blockquote': {
                borderLeft: '4px solid #ccc',
                margin: '1em 0',
                paddingLeft: '1em',
                fontStyle: 'italic',
                color: '#666'
              },
              '& a': {
                color: primaryColor,
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              },
              '& strong, & b': {
                fontWeight: 'bold'
              },
              '& em, & i': {
                fontStyle: 'italic'
              }
            }}
          >
            {parse(announcement.body)}
          </Box>
        </Box>


      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          background: '#fafafa',
          borderTop: '1px solid #e0e0e0'
        }}
      >
        <Button
          onClick={(e) => onClose(e, 'buttonClick')}
          variant="contained"
          sx={{
            background: primaryColor,
            color: 'white',
            px: 4,
            py: 1,
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '12px',
            '&:hover': {
              background: primaryColor,
              transform: 'translateY(-1px)',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
            },
            transition: 'all 0.3s ease'
          }}
        >
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AnnouncementItemDialog;